import { useState, useCallback, useEffect, useMemo, useReducer, useRef, useContext, useDebugValue } from 'react';
import { useToast } from '../contexts/ToastContext';

const useApi = (apiFunction, {showSuccessToast = true,showErrorToast = true, msg=''}={}) => {

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const { showSuccess, showError } = useToast();

  // Use useCallback to memoize the callApi function
  const callApi = useCallback(async (...args) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await apiFunction(...args);

      if(!result.success){
        console.log("Api call failed")
        console.log(result)
        console.log(result.error)
        console.log(result.errorData)
        
        // Handle validation errors from Django serializers
        let errorMessage = result.error;
        if (result.errorData && typeof result.errorData === 'object') {
          // Extract field-specific errors from Django serializer errors
          const fieldErrors = [];
          for (const [field, errors] of Object.entries(result.errorData)) {
            if (Array.isArray(errors)) {
              fieldErrors.push(...errors);
            } else if (typeof errors === 'string') {
              fieldErrors.push(errors);
            }
          }
          if (fieldErrors.length > 0) {
            errorMessage = fieldErrors.join(', ');
          }
        }
        
        setError(errorMessage);
        if (showErrorToast) {
          showError(errorMessage || 'Something went wrong');
        }
      }
      if(result.success){
        console.log("from the useAPI");
        console.log(result)
        setData(result.data);
        if (showSuccessToast) {
          showSuccess(msg || result.message || 'Operation successful');
        }
      }

      return result.data; // Return the result for further processing if needed
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [apiFunction]); // Only depends on apiFunction

  return { data, loading, error, successMessage, callApi, setData, setError, setSuccessMessage };
};

export default useApi;